import request from '@/api/config/request'

const prex = "api/simples_nacional";

export function listPeriodoDivergencia(eco_codigo) {
    return request({
        url: `${prex}/periodos_divergencia/${eco_codigo}`,
        method: 'get'
    })
}

export function listApuracaoSimplesNacional(eco_codigo, aps_competencia) {
    return request({
        url: `${prex}/apuracao_simples/${eco_codigo}/${aps_competencia}`,
        method: 'get'
    })
}
